<template>
  <v-app>
    <v-app-bar app color="primary" dark>
      <v-app-bar-nav-icon
        @click="drawer = !drawer"
        v-if="user"
      ></v-app-bar-nav-icon>
      <v-toolbar-title class="font-weight-bold"
        >Simple Shopping List</v-toolbar-title
      >
    </v-app-bar>
    <v-navigation-drawer v-model="drawer" app v-if="user">
      <v-list shaped>
        <v-list-item-group color="primary">
          <v-list-item to="/">Lists</v-list-item>
          <v-list-item to="/settings">Settings</v-list-item>
        </v-list-item-group>
      </v-list>
      <template v-slot:append>
        <div class="pa-2">
          <v-btn rounded block color="primary" @click="logOut()">Logout</v-btn>
        </div>
      </template>
    </v-navigation-drawer>
    <v-content>
      <router-view />
    </v-content>
  </v-app>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import firebase from "firebase";
export default {
  name: "Shopping-List-App",
  data() {
    return {
      drawer: false
    };
  },
  computed: {
    ...mapState(["user", "darkMode"])
  },
  created() {
    if (this.darkMode == true) {
      return (this.$vuetify.theme.dark = true);
    } else {
      return (this.$vuetify.theme.dark = false);
    }
  },
  methods: {
    ...mapMutations(["setUser"]),
    logOut() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.$router.push("login");
          this.setUser(null);
          this.drawer = false;
        });
    }
  }
};
</script>

<style lang="scss"></style>
